export default {
  name: "FooterSection",
  data(){
    return({
      rights:{
        company_name: "Bolide",
        year: new Date().getFullYear()
      }
    })
  }
};
